import ReportGroup from '../../../model/ReportGroup'
import { loadReportGroupList as apiLoadReportGroupList } from '../../../rest-api/ReportGroups-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const LoadReportGroupList = actionCreator.async<null, ReportGroup[], string>(
  'LoadReportGroupList'
)

const loadReportGroupConfigListWorker = wrapAsyncWorker(LoadReportGroupList, apiLoadReportGroupList)

// thunk action creator
export const loadReportGroupList = () => {
  return (dispatch: Dispatch<AnyAction>) => loadReportGroupConfigListWorker(dispatch, null)
}
